import apiClient from './api';

class SettingsService {
  /**
   * Get Site Lock Status
   * @returns {Promise} - Site lock configuration
   */
  async getSiteLock() {
    try {
      const response = await apiClient.get('/admin/settings/site-lock/');

      return {
        success: true,
        data: response.data,
      };
    } catch (error) {
      console.error('Error fetching site lock status:', error);

      let message = 'Failed to fetch site lock status';

      if (error.response) {
        if (error.response.status === 403) {
          message = 'Access denied. Admin privileges required.';
        } else if (error.response.status === 401) {
          message = 'Authentication required. Please log in again.';
        } else if (error.response.data?.detail) {
          message = error.response.data.detail;
        }
      } else if (error.request) {
        message = 'Unable to connect to server. Please check your connection.';
      }

      return {
        success: false,
        error: message,
      };
    }
  }

  /**
   * Update Site Lock Settings
   * @param {Object} data - { is_locked: boolean, password?: string }
   * @returns {Promise} - Updated site lock configuration
   */
  async updateSiteLock(data) {
    try {
      const response = await apiClient.patch('/admin/settings/site-lock/', data);

      return {
        success: true,
        data: response.data,
      };
    } catch (error) {
      console.error('Error updating site lock:', error);

      let message = 'Failed to update site lock settings';

      if (error.response) {
        if (error.response.status === 403) {
          message = 'Access denied. Admin privileges required.';
        } else if (error.response.status === 401) {
          message = 'Authentication required. Please log in again.';
        } else if (error.response.data?.detail) {
          message = error.response.data.detail;
        }
      } else if (error.request) {
        message = 'Unable to connect to server. Please check your connection.';
      }

      return {
        success: false,
        error: message,
      };
    }
  }
}

export default new SettingsService();
